import React from "react";
import { useQuery } from "@tanstack/react-query";
import { apiRoot } from "services/src/config";

import CommonCard from "components-v2/kpi/common-card";

import { HOME_CARD_CONTENT } from "@/modules/home/constants";

export default function UtilizationCard({ onClick, cardData }) {
  const { data, isLoading } = useQuery({
    queryKey: ["utilization"],
    queryFn: async () => {
      const response = await apiRoot.get("kpi/utilization");
      return response.data;
    },
  });

  const utilization = data?.utilization ?? 0;
  const totalLogged = data?.loggedHours ?? 0;
  const totalPayroll = data?.availableHours ?? 0;



  const { title, description } = HOME_CARD_CONTENT.utilization;

  return (
    <CommonCard
      title={title}
      info={description}
      onClick={onClick}
      cardData={{
        title: title,
        description: description,
        value: isLoading ? "0" : utilization,
        unit: "%",
        details: [
          { label: "Logged Hours", value: `${totalLogged}h` },
          { label: "Available Hours", value: `${totalPayroll}h` },
        ],
      }}
      percentage={utilization}
      isLoading={isLoading}

    />
  );
}
